import { useCallback, useEffect } from 'react';
import styles from './loginpage.module.css';
import logo from '../../assets/logo.svg';
import { Button, Form, Input, message } from 'antd';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux';
import actions from './redux/actions';
import { useNavigate } from 'react-router-dom';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';

const LoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const loggedIn = useSelector<RootState>((state) => state.auth.loggedIn);
    const loggingIn = useSelector((state: RootState) => state.auth.loggingIn);
    const error = useSelector((state: RootState) => state.auth.error);

    useEffect(() => {
        if (loggedIn) navigate('/');
    }, [loggedIn, navigate]);

    useEffect(() => {
        if (error) message.error(error.message);
    }, [error]);

    const doLogin = useCallback(
        (values: { username: string; password: string }) =>
            dispatch(actions.login(values)),
        [dispatch]
    );

    return (
        <div className={styles.container}>
            <div className={styles.leftPane}>
                <Form
                    className={styles.loginForm}
                    layout="vertical"
                    hideRequiredMark
                    onFinish={doLogin}
                >
                    <Form.Item>
                        <div className={styles.heading}>
                            <img
                                src={logo}
                                className={styles.logo}
                                alt="logo"
                            />
                            <h2>Inicia sesión</h2>
                        </div>
                    </Form.Item>
                    <Form.Item
                        name="username"
                        label="Correo electrónico"
                        rules={[
                            {
                                required: true,
                                message: 'Ingresa tu correo electrónico',
                            },
                        ]}
                    >
                        <Input
                            prefix={
                                <UserOutlined className="site-form-item-icon" />
                            }
                            placeholder="ejemplo@email.com"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Contraseña"
                        rules={[
                            {
                                required: true,
                                message: 'Ingresa tu contraseña',
                            },
                        ]}
                    >
                        <Input
                            prefix={
                                <LockOutlined className="site-form-item-icon" />
                            }
                            type="password"
                            placeholder="Contraseña"
                        />
                    </Form.Item>
                    {/* <Form.Item style={{textAlign:'right'}}>
            <a className="login-form-forgot" href="">
              ¿Olvidaste tu contraseña?
            </a>
          </Form.Item> */}

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            loading={loggingIn}
                        >
                            Iniciar sesión
                        </Button>
                    </Form.Item>
                </Form>
            </div>
            <div className={styles.rightPane}>
                <div className={styles.copy}>
                    Con <strong>Intrena QR</strong> puedes{' '}
                    <span>
                        promocionar, evaluar, medir, valorar, informar,
                        comprobar
                    </span>
                    el servicio y conocer la percepción de tus clientes,
                    usuarios y colaboradores.
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
